/**
 * Function that Capitalises a string
 * @param {*} $string 
 * @returns 
 */
export default function capitalise($string) {
    return $string.charAt(0).toUpperCase() + $string.slice(1);
}